import {Tabs} from 'antd';
import React from 'react';

import BillingHistory from './BillingHistory/BillingHistory';
import BillingScreen from './BillingScreen/BillingScreen';

const BillingScreenTabs = () => {
  const items = [
    {
      key: '1',
      label: 'Generate Bill',
      children: <BillingScreen />,
    },
    {
      key: '2',
      label: 'Bill History',
      children: <BillingHistory />,
    },
  ];

  return (
    <div className={'bg-white rounded-xl'}>
      <h1 className={'header mt-4'}>
            Billing Management
      </h1>
      <Tabs
        defaultActiveKey={'1'}
        items={items}
        className={'custom-tabs'}
      />
    </div>
  );
};

export default BillingScreenTabs;
